import React, { FC } from 'react';

import SeoLocationHero from '@rover/react-lib/src/pages/landing/SeoLocation/components/SeoLocationHero';
import type { ApiGroomingSearchRetrieveParams } from '@rover/rsdk/src/apiClient/latest/model/apiGroomingSearchRetrieveParams';
import type { SeoLocationDetails } from '@rover/rsdk/src/apiClient/latest/model/seoLocationDetails';

import { groomingHeroImage } from '../images';

import GroomingSearchForm from './GroomingSearchForm';

// Pet_Grooming_Hero.webp is exported at 585x561 rather than the 600x400 the other
// service hero art uses, so the hero needs its own ratio to avoid letterboxing.
const HERO_IMAGE_ASPECT_RATIO = 585 / 561;

type Props = {
  details: SeoLocationDetails;
  searchParams: ApiGroomingSearchRetrieveParams;
};

const GroomingSeoLocationHero: FC<Props> = ({ details, searchParams }) => (
  <SeoLocationHero
    heading={details.h1}
    subheading={details.h2}
    desktopImage={groomingHeroImage}
    imageMaxHeight="509px"
    imageAspectRatio={HERO_IMAGE_ASPECT_RATIO}
    imageAlignment="right"
    petType={details.petType}
    internalServiceTypeSlug={details.internalServiceType.slug}
    serviceTypeName={details.serviceTypeName}
    locationName={details.name}
    searchForm={<GroomingSearchForm initialParams={searchParams} />}
  />
);

export default GroomingSeoLocationHero;
